import type {LocationDetectedVariant, PickupStation} from '@logistics-frontend/types/logistic-dispatcher/external-api'

import type {NddClaimStation} from '../outer'
import type {Point} from './point'

export type SourcePoint = Point & {
  _type: 'source'
  _deliveryMethod: SourcePointDeliveryMethod
  // станция, или избранный адрес (только для NDD)
  station?: NddClaimStation
  // Пункт приема заказа (только для NDD)
  dropOffPoint: {
    city?: LocationDetectedVariant
    point?: PickupStation
  }
  // Выкуп товара. Курьер оплатит посылку и возьмёт за неё деньги с получателя
  cashOnDelivery: boolean
}

export const enum SourcePointDeliveryMethod {
  Station = 'station',
  DropOffPoint = 'dropOffPoint',
}
